// document.body.classList.add("loading-hidden");

document.addEventListener("DOMContentLoaded", async function () {
  let discoverPhrase = sessionStorage.getItem("discoverPhrase");
    const loaderDiv = document.createElement("div");
  loaderDiv.className = "questionnaire-loader-overlay";
  loaderDiv.innerHTML = `
    <div class="questionnaire-loading page-width" style="display: block;">
    <div class="top">
        <h2 class="title-heading">
        Your <em>${discoverPhrase}</em> Is Almost Here!
      </h2>
      <p class="description">Based on your answers, we’re preparing your perfect sleep routine. Please wait a moment for your personalized results and expert recommendations.</p>
    </div>
    <div class="loading">
      <svg class="spinner-svg" viewBox="0 0 50 50">
        <defs>
          <linearGradient id="spinner-gradient" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#4b7891" stop-opacity="1"></stop>
            <stop offset="100%" stop-color="#4b7891" stop-opacity="0"></stop>
          </linearGradient>
        </defs>
        <circle cx="25" cy="25" r="20" fill="none" stroke="url(#spinner-gradient)" stroke-width="3" stroke-linecap="round" stroke-dasharray="90 110" stroke-dashoffset="0"></circle>
      </svg>

        <p class="loader-text">Please wait a few seconds while we prepare your results...</p>
    </div>
  </div>
  `;

  const mainContent = document.getElementById("MainContent");
  // mainContent.classList.remove("loading-hidden");
  mainContent.prepend(loaderDiv);

   // let domain = "http://127.0.0.1:8002";
  let domain = "https://bhealth.maquae.com/agent";

  let questionnaireResponse = JSON.parse(
    sessionStorage.getItem("selectedValues")
  );

  // console.log(questionnaireResponse);
  // console.log(typeof questionnaireResponse);
  // console.log(questionnaireResponse[1]);
  

  const response = await fetch(domain + "/fetch-product-recommendation", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(questionnaireResponse),
  });

  if (!response.ok) {
    console.log("Failed to fetch product recommendation");
    return;
  }

  let data = await response.json();

  let handles = data["handles"];
  let metafields = data["metafields"]

  let mainTitle = document.querySelector('.questionnaire-rich-text .content-container .rich-text__wrapper h2 em');
  mainTitle.textContent = discoverPhrase;

  let whatsIncluded = document.querySelector('.bundle-included-section');

  whatsIncluded.style.display = "none";

  console.log(metafields);
    // console.log(handles);

  // let handles = [
  //   "the-ultimate-bundle-for-mom",
  //   "doze-promotes-sleep",
  //   "omega-5x",
  //   "dhh-b-mood-support",
  //   "epicatechin-muscle-growth-support",
  // ];

  console.log(handles);

  let productPromises = handles.map((handle) =>
    fetch(`/products/${handle}.js`).then((res) => {
      if (!res.ok) {
        return null;
      }
      return res.json();
    })
  );

  let products = await Promise.all(productPromises);

  products = products.filter((product) => product !== null);

  console.log(products);

  let bundleVendor = document.querySelector(".bundle-product-vendor");
  let bundleTitle = document.querySelector(".bundle-product-title");
  let bundleDescription = document.querySelector(".bundle-product-description");
  let bundleProductPrice = document.querySelector(".bundle-product-price");
  let bundleImages = document.querySelectorAll(".bundle-product-image");

  // console.log(bundleImages);
  // console.log(bundleImages.length);

  bundleVendor.innerHTML = products[0]["vendor"];
  bundleTitle.innerHTML = products[0]["title"];
  bundleDescription.innerHTML = ``;

  metafields.forEach((field) => {
    if (field['key'] == "short_description"){
      bundleDescription.innerHTML = field['value'];
    }
  })
  
  bundleProductPrice.innerHTML = `Dhs. ${(
    parseFloat(products[0]["price"]) / 100
  ).toFixed(2)}`;

  let productImages = products[0]["images"];
  console.log(productImages);

  // bundleImages[0].src = productImages[0];

  if (bundleImages.length > 0) {
    bundleImages.forEach((image, index) => {
      image.src = "";

      if (productImages[index]) {
        image.src = productImages[index];
      }
    });
  }

  let pickedBrand = document.querySelectorAll(".caption-with-letter-spacing");
  let pickedTitle = document.querySelectorAll(
    ".questionnare-recommendation .handpicked-section .handpicked-products-grid .product-card-wrapper .card--standard .card__information .card__heading .full-unstyled-link"
  );
  let pickedPrice = document.querySelectorAll(
    ".price__regular .price-item--regular"
  );
  let pickedImagesContainer = document.querySelectorAll(
    ".handpicked-section .card__inner .card__media .media"
  );

  // console.log(pickedBrand);
  // console.log(pickedTitle);
  // pickedTitle.forEach((title) => {
  //   console.log(title.innerHTML);
  // });
  // console.log(pickedPrice);

  products.forEach((product, index) => {
    if (index > 0) {
      pickedBrand[index - 1].innerHTML = product["vendor"];
      pickedPrice[index - 1].innerHTML = `Dhs. ${(
        parseFloat(product["price"]) / 100
      ).toFixed(2)}`;

      // console.log(index);
      // console.log(product);
      // console.log(product["vendor"]);
      // console.log(pickedBrand[index - 1]);
      // console.log(product["price"]);
      // console.log(pickedPrice[index - 1]);
      // console.log(pickedImagesContainer[index - 1]);

      let pickedImages =
        pickedImagesContainer[index - 1].querySelectorAll("img");

      pickedImages.forEach((image, index) => {
        image.src = "";
        image.srcset = "";

        if (index === 0) {
          if (product["images"][0]) {
            image.src = product["images"][0];
          }
        } else {
          if (product["images"][1]) {
            image.srcset = product["images"][1];
          }
        }

        // console.log(image);
      });

      let baseIndex = (index - 1) * 2;

      if (pickedTitle[baseIndex] && pickedTitle[baseIndex + 1]) {
        pickedTitle[baseIndex].innerHTML = product["title"];
        pickedTitle[baseIndex].href = product["url"];
        pickedTitle[baseIndex + 1].innerHTML = product["title"];
        pickedTitle[baseIndex + 1].href = product["url"];

        // console.log("baseIndex:", baseIndex);
        // console.log("pickedTitle[baseIndex]:", pickedTitle[baseIndex]);
        // console.log(
        //   "pickedTitle[baseIndex] content:",
        //   pickedTitle[baseIndex].innerHTML
        // );
        // console.log("pickedTitle[baseIndex + 1]:", pickedTitle[baseIndex + 1]);
        // console.log(
        //   "pickedTitle[baseIndex + 1] content:",
        //   pickedTitle[baseIndex + 1].innerHTML
        // );
      }
    }
  });

  
  let categoryId = parseInt(sessionStorage.getItem('categoryId'));

  console.log(categoryId);

  let collectionsMap = {
    "sport-recovery": 1,
    "longevity-aging": 10,
    "brain-focus": 11,
    "sleep-stress": 12,
    "detox-liver-health": 13,
    "gut-digestion-1": 14,
    "skin-hair-nails": 15
  }

  let collectionHandle = Object.keys(collectionsMap).find(
    key => collectionsMap[key] === categoryId
  );

  console.log(collectionHandle);

  let res = await fetch(`/collections/${collectionHandle}/products.json`);
  let collection_data = await res.json();
  let collection_products = collection_data.products;
  
  console.log(collection_products);

  let recommendationCollection = document.querySelectorAll('.recommendation-collection-list .card');

  // console.log(recommendationCollection);

  recommendationCollection.forEach((product, index) => {
    let vendor = product.querySelector('.card__information .caption-with-letter-spacing');
    let titles = product.querySelectorAll('.card__information .card__heading .full-unstyled-link');
    let prices = product.querySelectorAll('.card__information .price-item');
    let images = product.querySelectorAll('.card__media .media img');

    console.log(images);

    vendor.innerHTML = collection_products[index]['vendor'];

    titles.forEach((title) => {
      title.innerHTML = collection_products[index]['title'];
      title.href = `/produts/${collection_products[index]['handle']}`;
    })

    prices.forEach((price) => {
      price.innerHTML = `Dhs. ${collection_products[index]['variants'][0]['price']}`;
    })

    images.forEach((image, img_index) => {
      image.src = "";
      image.srcset = "";
      
      if (img_index === 0){
        image.src = collection_products[index]['images'][0]['src'];
      } else{
        image.srcset = collection_products[index]['images'][0]['src'];
      }
    })

  })
    
  loaderDiv.remove();
  mainContent.classList.remove("loading-hidden");
  
});
